import { CheckCircle } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import GolfIcon from '../GolfIcon';

interface ClubAmenitiesProps {
  drivingRange?: boolean;
  puttingGreen?: boolean;
  chippingGreen?: boolean;
  practiceBunker?: boolean;
  motorCart?: boolean;
  pullCart?: boolean;
  golfClubsRental?: boolean;
  clubFitting?: boolean;
  proShop?: boolean;
  golfLessons?: boolean;
  caddieHire?: boolean;
  restaurant?: boolean;
  receptionHall?: boolean;
  changingRoom?: boolean;
  lockers?: boolean;
  lodgingOnSite?: boolean;
}

export default function ClubAmenities({
  drivingRange,
  puttingGreen,
  chippingGreen,
  practiceBunker,
  motorCart,
  pullCart,
  golfClubsRental,
  clubFitting,
  proShop,
  golfLessons,
  caddieHire,
  restaurant,
  receptionHall,
  changingRoom,
  lockers,
  lodgingOnSite,
}: ClubAmenitiesProps) {
  const { t } = useTranslation();
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 bg-card rounded-lg p-2 text-sm">
      {/* {drivingRange && (
        <div className="flex items-center">
          <CheckCircle className="mr-2" />
          {t('driving_range')}
        </div>
      )} */}
      {/* {puttingGreen && (
        <div className="flex items-center">
          <CheckCircle className="mr-2" />
          {t('putting_green')}
        </div>
      )} */}
      {/* {chippingGreen && (
        <div className="flex items-center">
          <CheckCircle className="mr-2" />
          {t('chipping_green')}
        </div>
      )} */}
      {/* {practiceBunker && (
        <div className="flex items-center">
          <CheckCircle className="mr-2" />
          {t('practice_bunker')}
        </div>
      )} */}
      {motorCart && (
        <div className="flex items-center">
          <img src="/assets/images/icons/cart.svg" className='size-5 mr-2 dark:invert' />
          {t('golf_cart')}
        </div>
      )}
      {pullCart && (
        <div className="flex items-center">
          <GolfIcon name="manual-cart" className='size-5 mr-2 dark:invert' />
          {t('pull_cart')}
        </div>
      )}
      {golfClubsRental && (
        <div className="flex items-center">
          <GolfIcon name="golf-bag-2" className='size-5 mr-2 dark:invert' />
          {t('golf_rentals')}
        </div>
      )}
      {/* {clubFitting && (
        <div className="flex items-center">
          <img src="/assets/images/icons/golf-bat.svg" className='size-5 mr-2 dark:invert' />
          {t('club_fitting')}
        </div>
      )} */}
      {proShop && (
        <div className="flex items-center">
          <GolfIcon name="pro-shop" className='size-5 mr-2 dark:invert' />
          {t('pro_shop')}
        </div>
      )}
      {golfLessons && (
        <div className="flex items-center">
          <GolfIcon name="teacher" className='size-5 mr-2 dark:invert' />
          {t('golf_lessons')}
        </div>
      )}
      {caddieHire && (
        <div className="flex items-center">
          <CheckCircle className='size-5 mr-2 dark:invert' />
          {t('caddie_hire')}
        </div>
      )}
      {restaurant && (
        <div className="flex items-center">
          <GolfIcon name="restaurant" className='size-5 mr-2 dark:invert' />
          {t('restaurant')}
        </div>
      )}
      {receptionHall && (
        <div className="flex items-center">
          <GolfIcon name="club" className='size-5 mr-2 dark:invert' />
          {t('reception_hall')}
        </div>
      )}
      {changingRoom && (
        <div className="flex items-center">
          <img src="/assets/images/icons/hanger.svg" className='size-5 mr-2 dark:invert' />
          {t('changing_room')}
        </div>
      )}
      {lockers && (
        <div className="flex items-center">
          <img src="/assets/images/icons/lockers.svg" className='size-5 mr-2 dark:invert' />
          {t('lockers')}
        </div>
      )}
      {lodgingOnSite && (
        <div className="flex items-center">
          <CheckCircle className="mr-2" />
          {t('lodging_on_site')}
        </div>
      )}
    </div>
  );
}
